// src/config.js

// Адрес бэкенд-сервера
const isDevelopment = process.env.NODE_ENV === 'development';

const getDevelopmentApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  const browserHost = typeof window !== 'undefined' ? window.location.hostname : '';
  const backendHost = browserHost && browserHost !== '0.0.0.0' ? browserHost : '192.168.88.6';

  return `http://${backendHost}:8000`;
};

export const API_URL = isDevelopment
  ? getDevelopmentApiUrl()  // Локальный API для разработки
  : '';  // Продакшен всегда ходит через относительный URL nginx
